import styled from 'styled-components'

export const Container = styled.div`

  .headerSelectFarm{
    background: #490026;
    height: 90px;
    padding-right: 120px;
    padding-left: 120px;
    display: flex;

    > div {
      position: absolute;
      z-index: 3;
      margin: 20px 0px 0px 30px;

      > button{
        font-size: 20px;
      }
    }

    > img {
      margin: auto;
      height: 65px;
    }

    @media (max-width: 1500px) {
      height: 75px;
      padding-right: 105px;
      padding-left: 105px;

      > div {
        margin: 15px 0px 0px 25px;
      }

      > img {
        margin: auto;
        height: 55px;
      }
    }

    @media (max-width: 1300px) {
      height: 65px;
      padding-right: 95px;
      padding-left: 95px;

      > div {
        margin: 10px 0px 0px 25px;
      }

      > img {
        margin: auto;
        height: 50px;
      }
    }

    @media (max-width: 1100px) {
      height: 55px;
      padding-right: 80px;
      padding-left: 80px;

      > div {
        margin: 5px 0px 0px 20px;
      }

      > img {
        margin: auto;
        height: 40px;
      }
    }

  }

  .contentSelectFarm {
    height: calc(100% - 180px);
    width: 100%;
    position: absolute;
    display: flex;

    > div {
      margin: 10px auto;
      //height: 90%;
      width: 50%;
      background: #FFFDFD;
      border-radius: 48px;
      border: 1px solid rgba(52, 60, 68, 0.22);
      padding: 20px;

      .contentSelectFarmText{
        height: 80px;
        text-align: center;
        font-size: 32px;
        line-height: 43px;
        font-weight: 700;
        color: #490026;
        margin-bottom: 40px;
        font-family: Manrope;

        span {
          display: block
        }
      }

      .contentSelectFarmFiltro{
        
      }

      .contentSelectFarmList{
        height: calc(100% - 120px);

        form {
          height: 100%;

          > div:nth-child(2) {
            height: 100%;
          }
        }
      }
    }

    @media (max-width: 1500px) {
      height: calc(100% - 150px);

      > div {
        margin: 10px auto;
        padding: 10px;

        .contentSelectFarmText{
          height: 65px;
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 10px;
        }

        .contentSelectFarmList{
          height: calc(100% - 90px);
        }
      }
    
    }

    @media (max-width: 1300px) {
      height: calc(100% - 130px);

      > div {
        margin: 10px auto;
        padding: 10px;

        .contentSelectFarmText{
          height: 65px;
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 10px;
        }

        .contentSelectFarmList{
          height: calc(100% - 90px);
        }
      }
    
    }

    @media (max-width: 1100px) {
      height: calc(100% - 110px);

      > div {
        margin: 10px auto;
        padding: 10px;

        .contentSelectFarmText{
          height: 65px;
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 10px;
        }

        .contentSelectFarmList{
          height: calc(100% - 90px);
        }
      }
    }


  }

  .footerSelectFarm {
    bottom: 0px;
    position: fixed;
    width: 100%;
    height: 90px;
    display: flex;

    img {
      margin: 0 auto auto auto;
      height: 70px;
    }

    @media (max-width: 1500px) {
      height: 75px;

      > img {
        height: 55px;
      }
    }

    @media (max-width: 1300px) {
      height: 65px;

      > img {
        height: 50px;
      }
    }

    @media (max-width: 1100px) {
      height: 55px;

      > img {
        height: 40px;
      }
    }



  }
`
